<div class="chat-discussion-wrapper">
    <mat-card>
        <mat-card-header class="card-header">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="card-header-row">
                <div class="heading">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <div class="profile-photo">
                            <img *ngIf="!discussion.isGroup && null !== discussion.recipient?.user?.avatarUrl"
                                 ngSrc="{{ conf.storageRootUrl + discussion.recipient?.user?.avatarUrl}}"
                                 width="32" height="32"
                                 alt="avatar" class="avatar rounded-circle mr-2 ml-0">
                            <i class="material-icons" *ngIf="discussion.isGroup || null === discussion.recipient?.user?.avatarUrl">
                                supervised_user_circle
                            </i>
                            <span class="state"></span>
                        </div>
                        <div class="data">
                            <p class="name mb-0 mt-0"><strong>{{ discussion.displayName | truncate:[15, '...'] }}</strong></p>
                            <p class="activity mb-0 mt-0">
                                <span *ngIf="discussion.recipient?.seenAt">{{ 'ChatSeenAt' | translate }} {{ discussion.recipient?.seenAt??'' | dateClosest | lowercase }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="icons">
                    <button mat-icon-button [matMenuTriggerFor]="discussionMenu" aria-label="Discussion menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #discussionMenu="matMenu">
                        <button mat-menu-item (click)="deleteDiscussion()">
                            <mat-icon>visibility_off</mat-icon>
                            <span>{{ 'HideDiscussion' | translate }}</span>
                        </button>
                    </mat-menu>

                    <button mat-icon-button (click)="close()" matTooltip="{{ 'Close' | translate }}" matTooltipPosition="right">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content class="card-content">
            <div class="chat-messages" #chatMessages>

                <ng-container *ngIf="(messages$ | async) as messages; else loadingMessage">
                    <ng-container *ngIf="messages.length > 0; else emptyMessage">
                        <infinite-scroll (scrolled)="onScroll()">
                            <div class="messages-fetching" *ngIf="isLoading$ | async">
                                {{ 'ChatFetchingMessages' | translate }}
                            </div>

                            <app-chat-message *ngFor="let message of messages"
                                              [message]="message"
                                              [appUrl]="appUrl"
                                              [athleteUser]="athleteUser"
                                              [organization]="organization"
                                              [mobileDisplay]="mobileDisplay"
                                              (linkClickedEvent)="onLinkClicked($event)"
                                              (downloadClickedEvent)="onDownloadClicked($event)"
                            ></app-chat-message>

                        </infinite-scroll>
                    </ng-container>
                </ng-container>
            </div>
        </mat-card-content>
        <mat-card-footer class="card-footer">
            <div fxLayout="row" fxLayoutAlign="space-between center" >
                <div class="message-input">
                    <mat-form-field>
                        <textarea matInput
                                  #messageInput
                                  cdkTextareaAutosize
                                  placeholder="{{ 'ChatNewMessagePlaceholder' | translate }}"></textarea>
                    </mat-form-field>
                </div>
                <div class="message-actions">
                    <div fxLayout="row" fxLayoutAlign="end center" >
                        <div class="action-media">
                            <input type="file" #file style="display: none;" (change)="onFilesAdded()" />
                            <button
                                mat-icon-button
                                color="accent"
                                matTooltip="{{ 'SendFile' |translate }}"
                                (click)="selectFileMessage()"
                            >
                                <i class="material-icons">
                                    attach_file
                                </i>
                            </button>
                        </div>
                        <div class="action-send">
                            <button
                                mat-icon-button
                                color="accent"
                                matTooltip="{{ 'Send' |translate }}"
                                (click)="sendTextMessage(messageInput)"
                            >
                                <i class="material-icons">
                                    send
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-footer>
    </mat-card>
</div>

<ng-template #loadingMessage>
    <mat-spinner diameter="36"></mat-spinner>
</ng-template>

<ng-template #emptyMessage>
    <span class="discussion-empty">{{ 'ChatDiscussionEmpty' | translate }}</span>
</ng-template>
